import useNotification from "./useNotification";

export default function useApiClient() {
	const { showNotificationAlert, showNotificationSuccess } = useNotification();

	const displayError = (e: any) => {
		if (e.response?.data?.displayableError) {
			showNotificationAlert({
				content: e.response.data.message,
			});
		}
	};

	const displaySuccess = (message: string) => {
		showNotificationSuccess({
			content: message,
		});
	};

	const displayGQLMutationError = (errors: { httpStatus: number; message: string;}[]) => {
		console.log("errors", errors);
		errors?.forEach(e => {
			showNotificationAlert({
				content: e.message
			});
		});
	};

	return { displayError, displaySuccess, displayGQLMutationError };
}
